import React from "react";
import { Form } from "react-bootstrap";
import { TApiParameter } from "../../../../../api/endpoints/Parameter";
import { TParamLevelistOption } from "../../../../../api/endpoints/SubsetOption";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import ParamLevelistSelector from "../../../ParamLevelistSelector";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: TParamLevelistOption;
  options: { [shortname: string]: TApiParameter }
}

const ParametersLevelistField = (props: Props) => {
  const { formik, spec, options } = props;

  return (
    <Form.Group controlId="paramLevelist">
      <Form.Label>Parameters</Form.Label>
      <ParamLevelistSelector
        values={formik.values.param_levelist}
        spec={spec}
        params={options}
        onChange={values => formik.setFieldValue('param_levelist', values)}
      />

      <FormError
        message={formik.errors.param_levelist as TFormErrorMessage}
        when={formik.touched.param_levelist && Boolean(formik.errors.param_levelist)}
      />

      <Footnote text={spec.footnote} />
    </Form.Group>
  )
}

export default ParametersLevelistField;
